import { getMessageFactory } from "../getCaxaWebSocket.js";
const findHdfFileInfo = getMessageFactory({
  code: "FIND_HDF_FILE_INFO"
});
export { findHdfFileInfo };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/findHdfFileInfo.js